import { render, staticRenderFns } from "./AccountViewer.vue?vue&type=template&id=af979f08&scoped=true"
import script from "./AccountViewer.vue?vue&type=script&lang=js"
export * from "./AccountViewer.vue?vue&type=script&lang=js"
import style0 from "./AccountViewer.vue?vue&type=style&index=0&id=af979f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af979f08",
  null
  
)

export default component.exports